export default __webpack_public_path__ + "static/media/evo-blue.5bd1de18.jpeg";